import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ClockIcon from '@/lib/assets/clock.svg';

import styles from './../PaymentPage.module.scss';

const calculateTimeLeft = (timestamp) => {
    const now = Math.floor(Date.now() / 1000);
    const difference = timestamp - now;

    if (difference <= 0) {
        return { minutes: 0, seconds: 0 };
    }

    const minutes = Math.floor(difference / 60);
    const seconds = difference % 60;

    return { minutes, seconds };
};

const CountDown = ({ endTime, onPaymentResult, redirectURL }) => {
    const { t } = useTranslation();

    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft(endTime));
    const [expiredNotified, setExpiredNotified] = React.useState(false);

    React.useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft(endTime));

            if ((Date.now() / 1000) > endTime && !expiredNotified) {
                setExpiredNotified(true);
                onPaymentResult({ success: false, isTimeUp: true, data: { callback_url: redirectURL } });
            }
        }, 100);

        return () => clearInterval(interval);
    }, [endTime, redirectURL, onPaymentResult, expiredNotified]);

    return (
        <div className={styles.remaining_time}>
            <ClockIcon alt="clock"/>
            <p>{t('timeLeft')}: {t('minuteWithCount', { count: timeLeft.minutes })} {t('secondWithCount', { count: timeLeft.seconds })}</p>
        </div>
    );
};

CountDown.propTypes = {
    endTime: PropTypes.number,
    onPaymentResult: PropTypes.func,
    redirectURL: PropTypes.string,
};

export default CountDown;
